import Vue from "vue";
import VueStore from 'vue-j-store';
import VueRouter from 'vue-router';
import axios from 'axios';
import validator from "vue-j-validator";

import dialog from "../plugins/dialog/";
// import lazyload from "../plugins/lazyload/";
import dragload from "../plugins/dragload/";
import verify from "../plugins/verify/";
import VueCookie from 'vue-cookie';

   /**
    * 重写源码KeepAlive，以便路由控制KeepAlive，以及和<transition>结合运用
    */
//    var KeepAlive=Vue.options.components.KeepAlive,
//        oldRender=KeepAlive.render;
//    KeepAlive.render=function(){
//        var vnode=oldRender.call(this);
//        vnode&&(vnode.data.keepAlive =this.$route.meta.keepAlive);
//        return vnode;
//    };


if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        'use strict';
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

window.raf=window.requestAnimationFrame||window.webkitRequestAnimationFrame||function(f){return setTimeout(f,1.6666)};
window.caf=window.cancelAnimationFrame||window.webkitCancelAnimationFrame||function(f){return clearTimeout(f)};

VueStore.prototype.$http=Vue.prototype.$http=axios;

Vue.prototype.throttle=function(f,interval){
    var timer=0;
    return function(e){
        if(timer)return;
        timer=setTimeout(function(){
            f.call(this,e);
            timer=0;
        }.bind(this),interval);
    }
};

Vue.prototype.debound=function(f,delay){
    var timer;
    delay=delay||200;
    return function(e){
        clearTimeout(timer);
        timer=setTimeout(f.bind(this,e),delay);
    };
};

Vue.prototype.getFormData=function(form){
    var data=[],els=form.elements,el,i=els.length,name,value;
    while(i--){
       el=els[i];
       name=els[i].name;
       if(name){
           if((el.type==="checkbox"||el.type==="radio")&&!el.checked){
               continue;
           }
           value=data[name];
           data.push(name+"="+encodeURIComponent(el.value));
       }
    }

    return data.join("&");
};

/* 设备检测 */
window.isHandheldDevice=/\b(?:Android|webOS|iPhone|iPod|iPad|BlackBerry)\b/i.test(navigator.userAgent);

if(!window.isHandheldDevice){
    document.documentElement.classList.add("pc");
}

//时间格式化
Date.format=function(type,time){
    var t=time instanceof Date?time:new Date(time),_f=this._formatMap||(this._formatMap={
        reg:/y+|M+|d+|h+|m+|s+/g,
        y:"getFullYear",
        M:"getMonth",
        d:"getDate",
        h:"getHours",
        m:"getMinutes",
        s:"getSeconds",
        run:function(t,match){
            var m=match[0],expand=m==="M"?10001:10000;
            return (t[this[m]]()+expand).toString().slice(-match.length);
        }
    });
    return type.replace(_f.reg,function(a){
         return _f.run(t,a);
    });
};


//订阅者
function EventEmitter(settings){
   Object.assign(this,settings);
   this._listeners=Object.create(null);
}
EventEmitter.prototype={
   on:function(t,f){
       var evts=this._listeners[t]||(this._listeners[t]=[]);
      evts.indexOf(f)===-1&&evts.push(f);
      return this;
   },
   off:function(t,f){
       var i,evts=this._listeners[t];
       if(!evts)return this;

       if(f){
           i=evts.indexOf(f);
           i===-1||evts.splice(i,1);
       }
       else
       {
         evts.length=0;
       }
       return this;
   },
   emit:function(t){
     var evts=this._listeners[t],i=0,ii,args;
     if(!evts)return this;

     ii=evts.length;
     args=[].slice.call(arguments,1);
     while(i<ii){
         evts[i++].apply(null,args);
     }
     return this;
   }
};
window.EventEmitter=EventEmitter;


Vue.use(VueRouter)
.use(VueStore)
.use(validator,{
    callback(err){
        if(err){
          Vue.prototype.$tip(err);
        }
    }
})
.use(dialog)
// .use(lazyload)
.use(dragload,{$http:axios})
.use(VueCookie)
.use(verify,"api/user-verify?");       //图片验证码地址







// WEBPACK FOOTER //
// ./src/common/use.js